
import style from '../../../styles/mystyle.module.css'
import {Navbar} from '../Layout/Navbar'
// import { useMedia } from "../../../utils/use-media";
import dynamic from 'next/dynamic'
const PhoneSearch =dynamic(()=>import('./PhoneSearch'),{ssr:false})
// const FormSearch =dynamic(()=>import('../FormSearch'),{ssr:false})
const HomeHakeemMedical =dynamic(()=>import('./HomeHakeemMedical'),{ssr:false})
const MedicalCard =dynamic(()=>import('./MedicalCard'),{ssr:false})
// const FoodSearchForm =dynamic(()=>import('./FoodSearchForm'),{ssr:false})
// const MedicalSearchForm =dynamic(()=>import('./MedicalSearchForm'),{ssr:false})
import { useRouter } from "next/router";
function WhiteMedical({statusIds,days,isInSearchPage,foodSearchLst,medicalEntityTypeLst,entityTypes}) {
    // const mobile = useMedia("(max-width: 580px)");
    const router = useRouter()

    return (
        <div className={style.ContainerMargin} style={{ backgroundColor: "white" }}>
       
            <Navbar showDownloadAppSection={true} exchangeAllCurrenciesCallBack={(res)=>(res)} currenciesCallBack={(res)=>(res)}>
              
            <HomeHakeemMedical type={foodSearchLst.filter(r=>router.query.entityType&&router.query.entityType.split(',').includes(r)).length>0?foodSearchLst.filter(r=>router.query.entityType
                &&router.query.entityType.split(',').includes(r)).length>0 :false}>
        <PhoneSearch foodSearchLst={foodSearchLst} ></PhoneSearch>
              </HomeHakeemMedical>
                
 
         
              {router.asPath !="/profile#book"?
            <MedicalCard statusIds={statusIds} days={days} isInSearchPage={isInSearchPage}  foodSearchLst={foodSearchLst} entityTypes={entityTypes}/>
            :""}
     
            </Navbar>
        </div>
    )
}

export default WhiteMedical
